import { CustomArray } from "./BaseModel";

export enum MessageRole {
  assistant = "assistant",
  user = "user",
}
export enum MessageType {
  RAG = "RAG",
  FAQ = "FAQ",
  CHOICE = "CHOICE",
  NONE = "NONE",
}
export class Message {
  public readonly id!: string;
  public readonly threadId!: string;
  public readonly role!: MessageRole;
  public readonly sender!: string;
  public readonly recipient!: string;
  public readonly senderIcon?: string = undefined;
  public readonly type!: MessageType;
  public readonly content!: string;
  public readonly dataSources?: DataSources = undefined;
  public readonly choices?: Choices = undefined;
  public readonly createdAt!: Date;

  constructor(params: Message) {
    Object.assign(this, params);
  }
}

export class UserMessage extends Message {
  constructor(params: {
    id: string;
    threadId: string;
    sender: string;
    recipient: string;
    content: string;
    type?: MessageType;
  }) {
    super({
      ...params,
      type: params.type ?? MessageType.NONE,
      role: MessageRole.user,
      senderIcon: undefined,
      dataSources: undefined,
      choices: undefined,
      createdAt: new Date(),
    });
  }
}

export class Messages extends CustomArray<Message> {
  // 最後に宛先となっているサービスを取得する
  lastRecipientService(): string | undefined {
    const lastUserMessage = this.findLast(
      (message) => message.role == MessageRole.user,
    );
    const lastRecipient = lastUserMessage?.recipient;
    return lastRecipient;
  }

  choiceReflected(): Messages {
    // Create a copy of messages
    const updatedMessages = new Messages([...this]);

    // Find all choice messages from users
    updatedMessages.forEach((message, index) => {
      // Skip if not a user choice message or if it's the first message
      if (message.role !== MessageRole.user || message.type !== MessageType.CHOICE || index === 0) {
        return;
      }

      // Find the previous assistant message with choices
      const prevMessage = updatedMessages[index - 1];
      if (prevMessage.role === MessageRole.assistant && prevMessage.choices) {
        // Update choices to reflect selection
        prevMessage.choices.setSelected(message.content);
      }
    });

    return updatedMessages;
  }
}

export class DataSource {
  public readonly title!: string;
  public readonly url: string = "";
  public readonly content: string = "";
  public readonly section: string = "";
  constructor(params: DataSource) {
    Object.assign(this, params);
  }
}

export class DataSources extends CustomArray<DataSource> {
}

export class Choice {
  public readonly label: string = "";
  public readonly value: string = "";
  public selected?: boolean = undefined;
  constructor(params: Choice) {
    Object.assign(this, params);
  }
}

export class Choices extends CustomArray<Choice> {
  setSelected(value: string) {
    this.forEach((choice) => {
      choice.selected = choice.value === value;
    });
  }
}
